import { defineComponent as S, useCssVars as V, inject as f, ref as _, watch as g, computed as b, openBlock as o, createElementBlock as a, Fragment as h, createCommentVNode as s, createElementVNode as l, normalizeClass as m, toDisplayString as k, createVNode as B, renderSlot as w, renderList as E, createBlock as M, createTextVNode as A, pushScopeId as D, popScopeId as L } from "vue";
import R from "../../assets/IST_LOGO.WHITE_ONLY.svg.mjs";
import { NavigationItemComparer as T } from "./types.mjs";
import { pureSort as $ } from "../../utils/arrayUtils.mjs";
import j from "./IstMainNavigationItem.vue.mjs";
import z from "../skeleton/IstSkeleton.vue.mjs";
import "../skeleton/IstSkeleton.vue2.mjs";
import F from "../icon/IstIcon.vue.mjs";
const O = (u) => (D("data-v-a80f4d30"), u = u(), L(), u), W = {
  key: 0,
  class: "ist-menu-appname"
}, q = { class: "ist-menu-icon" }, G = {
  key: 0,
  "aria-label": "Site Menu"
}, H = { class: "ist-list-footer" }, J = {
  class: "ist-list",
  "aria-label": "footer-logo"
}, K = { class: "ist-list-item motto" }, P = ["title"], Q = /* @__PURE__ */ O(() => /* @__PURE__ */ l("br", null, null, -1)), ne = /* @__PURE__ */ S({
  __name: "IstMainNavigation",
  props: {
    appName: { default: "" },
    menu: { default: () => [] },
    currentRouteName: { default: void 0 },
    buildVersion: { default: "" },
    menuClosed: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    motto: { default: "" },
    mobilMenu: { type: Boolean, default: !1 }
  },
  emits: ["toggleMenu", "menuClicked"],
  setup(u, { emit: y }) {
    V((e) => ({
      "3a479a41": I.value
    }));
    const c = u, i = y, C = (e) => {
      i("menuClicked", e), n.value && r();
    }, d = f("mobile", c.mobilMenu), n = _(d);
    g(
      () => d,
      (e) => {
        n.value = e;
      }
    );
    const p = f("showMenu", !0), t = _(p);
    g(
      () => p,
      (e) => {
        t.value = e, i("toggleMenu", !t.value);
      }
    );
    const r = () => {
      t.value = !t.value, i("toggleMenu", !t.value);
    }, N = b(() => $(c.menu, T)), I = b(() => t.value ? "260px" : "64px");
    return (e, U) => (o(), a(h, null, [
      n.value && t.value ? (o(), a("div", {
        key: 0,
        class: "ist-menu_mobiledimmer ist-menu_mobiledimmershow",
        onClick: r
      })) : s("", !0),
      l("div", {
        class: m([{ "ist-leftmenu": !n.value }, "smallscrollbar"])
      }, [
        l("div", {
          class: m({ "ist-menu_mobile": n.value, "ist-menu_closed": !t.value && n.value })
        }, [
          n.value ? s("", !0) : (o(), a("div", {
            key: 0,
            class: "ist-logo-container",
            "aria-label": "Toggle Menu",
            onClick: r
          }, [
            t.value ? (o(), a("label", W, k(e.appName), 1)) : s("", !0),
            l("label", q, [
              B(F, {
                style: { margin: "auto" },
                name: t.value ? "r_menu_open" : "r_menu"
              }, null, 8, ["name"])
            ])
          ])),
          w(e.$slots, "default", {}, () => [
            e.loading ? s("", !0) : (o(), a("nav", G, [
              (o(!0), a(h, null, E(N.value, (v) => (o(), M(j, {
                key: v.title,
                closed: !t.value,
                "current-route-name": e.currentRouteName,
                item: v,
                onMenuClicked: C
              }, null, 8, ["closed", "current-route-name", "item"]))), 128))
            ])),
            e.loading ? (o(), M(z, {
              key: 1,
              "skeleton-type": "menu"
            })) : s("", !0)
          ], !0),
          l("div", H, [
            l("nav", J, [
              l("div", K, [
                l("img", {
                  alt: "logo",
                  title: "version:" + e.buildVersion,
                  src: R
                }, null, 8, P),
                e.motto ? (o(), a("span", {
                  key: 0,
                  class: m({ hideOnMenuClosed: !t.value })
                }, [
                  Q,
                  A(k(e.motto), 1)
                ], 2)) : s("", !0)
              ])
            ])
          ])
        ], 2)
      ], 2)
    ], 64));
  }
});
export {
  ne as default
};
